import React from 'react'
import { Image, View, type ImageSourcePropType } from 'react-native'
import { botAvatarFor } from '../../lib/botAvatars'

interface BotAvatarProps {
  profile: string
  size: number
}

/** Shared stable-bot portrait treatment used by the picker and Synthetic Command. */
export function BotAvatar({ profile, size }: BotAvatarProps) {
  const source = botAvatarFor(profile)
  const radius = size / 2

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        borderWidth: 2,
        borderColor: '#6b7d3a',
        backgroundColor: '#181f12',
        overflow: 'hidden',
      }}
      accessibilityElementsHidden
      importantForAccessibility="no"
    >
      {source && (
        <Image
          source={source as ImageSourcePropType}
          style={{ width: size, height: size }}
          resizeMode="contain"
        />
      )}
    </View>
  )
}
